import { saveAs } from 'file-saver'
import HttpServices from './Http.services'
import { imageAddress } from './useful'

export const requestFreshWorkflowDocument = (recordId, documentField) => (
    new Promise((resolve, reject) => {
        HttpServices.request(
            'refreshWorkflowDocument',
            { _id: recordId, documentField },
            (result, error) => {
                if (error || !result?.file?.address) {
                    reject(error || new Error('Workflow document was not generated'))
                    return
                }
                resolve(result)
            }
        )
    })
)

export const fetchFreshWorkflowDocumentBlob = async (recordId, documentField) => {
    const result = await requestFreshWorkflowDocument(recordId, documentField)
    const response = await fetch(imageAddress(result.file), { cache: 'no-store' })
    if (!response.ok) throw new Error('Download failed')
    const blob = await response.blob()
    if (!(await blob.slice(0, 5).text()).startsWith('%PDF-')) {
        throw new Error('Invalid PDF')
    }
    return { ...result, blob }
}

export const downloadFreshWorkflowDocument = async (
    recordId,
    documentField,
    fallbackName
) => {
    const result = await fetchFreshWorkflowDocumentBlob(recordId, documentField)
    saveAs(
        result.blob,
        result.file.originalName || fallbackName || `${documentField}.pdf`
    )
    return result
}
